import { render } from "./repair.vue?vue&type=template&id=6adaee2e&scoped=true&ts=true"
import script from "./repair.vue?vue&type=script&lang=ts"
export * from "./repair.vue?vue&type=script&lang=ts"

import "./repair.vue?vue&type=style&index=0&id=6adaee2e&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6adaee2e"]])

export default __exports__